import * as React from 'react';
import { styled } from '@mui/material/styles';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Collapse from '@mui/material/Collapse';
import IconButton, { IconButtonProps } from '@mui/material/IconButton';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, Grid, TextField, Autocomplete, Box, AppBar, Toolbar, Typography, FormControlLabel, Checkbox, FormGroup, FormControl, FormLabel, Divider, Tabs, Tab, Switch } from "@mui/material"
import { useClientesService } from "../../../../../../use-cases/clientes/useClientesService"
import { useAppSelector } from "../../../../../hooks/store-hooks"
import { useEffect, useState } from "react"
import SearchIcon from '@mui/icons-material/Search';
import { formatCnpj } from "../../../../../../utils"
import CloseIcon from '@mui/icons-material/Close';
import { useVendedorService } from "../../../../../../use-cases/vendedor";
import { useProdutoService } from '../../../../../../use-cases/produto';
import { usePlanoVelesService } from '../../../../../../use-cases/planos-veles';
import { PlanosVelesTab } from '../../../../../components/planos-veles/PlanosVelesTab';
import { NotaFiscalTab, NotaFiscalTabRef } from '../../../../../components/nota-fiscal/NotaFiscalTab';
import { PlanosVelesTabRef } from '../../../../../../application/models';
import { ContratoTab } from '../../../../../components/contrato/ContratoTab';
import { HistoricoPlanosTab } from '../../../../../components/planos-veles/HistoricoPlanosTab';
import { useTipoConsumoService } from '../../../../../../use-cases/tipo-consumo';

interface ExpandMoreProps extends IconButtonProps {
  expand: boolean;
}

const ExpandMore = styled((props: ExpandMoreProps) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
  marginLeft: 'auto',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
}));

// FORM PADRÃO
export const FormCreateCliente = () => {
  // state 
  const { produtosTipoConsumo } = useAppSelector((state) => state.produto)
  const { createClienteForm } = useAppSelector((state) => state.clientes)
  const { vendedores } = useAppSelector((state) => state.vendedor)
  const [expanded, setExpanded] = React.useState<{ [key: string]: boolean }>({});
  const [loading, setLoading] = useState<boolean>(true)
  const [tabValue, setTabValue] = React.useState(0);
  const [camposComErro, setCamposComErro] = React.useState<Set<string>>(new Set());
  const [searchTerms, setSearchTerms] = React.useState<{ [key: number]: string }>({});
  const planosVelesRef = React.useRef<PlanosVelesTabRef>(null);

  const notaFiscalRef = React.useRef<NotaFiscalTabRef>(null);
  const { setVendedores } = useVendedorService()

  // SERVICES MIGRADOS
  const { setAllProdutosAndTipoConsumo } = useTipoConsumoService()
  const { vincularTipoConsumoCreateClienteForm, removerTipoConsumoCreateClienteForm } = useTipoConsumoService()
  const {
    vincularProdutoCreateClienteForm,
    removerProdutoCreateClienteForm,
  } = useProdutoService()

  const {
    setCreateClienteFormCNPJ,
    setCreateClienteFormRazaoSocial,
    setCreateClienteFormNomeFantasia,
    setCreateClienteFormLogin,
    setCreateClienteFormVendedorId,
    setCreateClientesOpenForm,
    setCreateClienteFormInfoByCnpj,
    setCreateClienteFormGerarLoteFinanceiro,
    handleCreateCliente,
    handleTabChange,
    initializeCreateClienteForm,
    aplicarTiposConsumoPadrao,
  } = useClientesService()

  const { clearAllPlanoData, initializePlanoData } = usePlanoVelesService()

  const hasLoadedData = React.useRef(false);
  const hasAppliedDefaultTiposConsumo = React.useRef(false);

  const getErrorMessage = (fieldName: string): string => {
    if (camposComErro.has(fieldName)) {
      return 'Campo obrigatório';
    }

    if (createClienteForm.touched) {
      const error = createClienteForm.errors.find(item => item.key === fieldName);
      return error?.message || '';
    }

    return '';
  };

  const hasError = (fieldName: string): boolean => {
    return camposComErro.has(fieldName) ||
      Boolean(createClienteForm.touched && createClienteForm.errors.find(item => item.key === fieldName));
  };

  const handleExpandClick = (key: string) => {
    setExpanded((prevState) => ({
      ...prevState,
      [key]: !prevState[key],
    }));
  };

  useEffect(() => {
    const loadData = async () => {
      if (hasLoadedData.current) return;
      hasLoadedData.current = true;

      try {
        // Limpar estado do editClienteForm para evitar dados residuais
        initializeCreateClienteForm();

        await setVendedores();
        await setAllProdutosAndTipoConsumo();
        initializePlanoData(false, null, {} as any, false);
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };

    loadData();

    return () => {
      hasLoadedData.current = false;
      clearAllPlanoData();
    };
  }, [setVendedores, setAllProdutosAndTipoConsumo, initializePlanoData, clearAllPlanoData, initializeCreateClienteForm]);

  useEffect(() => {
    aplicarTiposConsumoPadrao(hasAppliedDefaultTiposConsumo);
  }, [
    produtosTipoConsumo,
    createClienteForm.fields.ProdutosTiposConsumos,
    aplicarTiposConsumoPadrao
  ]);

  const handleClose = () => {
    clearAllPlanoData();
    setCreateClientesOpenForm(false)
  }

  const handleTabChangeWrapper = async (event: React.SyntheticEvent, newValue: number) => {

    try {
      const result = await handleTabChange(tabValue, newValue, planosVelesRef, notaFiscalRef);

      if (typeof result === 'number') {
        setTabValue(result);
      } else {
        setTabValue(newValue);
      }
    } catch (error) {
      setTabValue(newValue);
    }
  };



  return (
    <>
      {
        loading ? null
          :
          <Dialog
            open={true}
            fullScreen
            onClose={handleClose}
            scroll={'paper'}
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
            PaperProps={{
              component: 'form',
              onSubmit: (event: React.FormEvent<HTMLFormElement>) => {
                event.preventDefault();
                handleCreateCliente(
                  event,
                  planosVelesRef,
                  notaFiscalRef,
                  setTabValue,
                  setCamposComErro
                );
              },
            }}
          >
            <AppBar sx={{ position: 'relative' }}>
              <Toolbar>
                <Typography sx={{ ml: 2, flex: 1 }} textTransform={"uppercase"} fontWeight={"bold"} variant="h6" component="div">
                  Criar Cliente
                </Typography>
                <Button
                  color="inherit"
                  startIcon={<>
                    <CloseIcon />
                  </>}
                  onClick={handleClose}
                  aria-label="close"
                >
                  Fechar
                </Button>
              </Toolbar>
            </AppBar>

            <DialogContent dividers={true}>
              <DialogContentText id="scroll-dialog-description" tabIndex={-1}></DialogContentText>
              <Box p={3}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
                  <Tabs value={tabValue} onChange={handleTabChangeWrapper} aria-label="formulário cliente">
                    <Tab label="Dados do Cliente" />
                    <Tab label="Produtos" />
                    <Tab label="Planos" />
                    <Tab label="Histórico de Planos" />
                    <Tab label="Contrato" />
                    <Tab label="Nota Fiscal" />
                  </Tabs>
                </Box>

                {tabValue === 0 && (
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <TextField
                        value={formatCnpj(createClienteForm.fields.cnpj)}
                        onChange={(e) => {
                          setCreateClienteFormCNPJ(e.target.value)
                        }}
                        error={hasError('cnpj')}
                        helperText={getErrorMessage('cnpj')}
                        name="cnpj"
                        fullWidth
                        id="cnpj"
                        label="CNPJ"
                        autoFocus
                        InputProps={{
                          endAdornment: (
                            <Button
                              onClick={(e) => {
                                setCreateClienteFormInfoByCnpj()
                              }}
                              title="Buscar empresa externa por CNPJ"
                              variant="outlined"
                              size="small"
                            >
                              <SearchIcon />
                            </Button>
                          )
                        }}
                      />
                      {createClienteForm.fields.isExternalSearch && (
                        <Box mt={1} p={1} bgcolor="success.light" borderRadius={1}>
                          <Typography variant="caption" color="success.contrastText">
                            ✓ Dados preenchidos automaticamente da busca externa
                          </Typography>
                        </Box>
                      )}
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        value={createClienteForm.fields.razaoSocial}
                        onChange={(e) => {
                          setCreateClienteFormRazaoSocial(e.target.value)
                        }}
                        error={hasError('razaoSocial')}
                        helperText={getErrorMessage('razaoSocial')}
                        name="razaoSocial"
                        fullWidth
                        id="razaoSocial"
                        label="Razão Social"
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        value={createClienteForm.fields.nomeFantasia || ''}
                        onChange={(e) => {
                          setCreateClienteFormNomeFantasia(e.target.value)
                        }}
                        error={hasError('nomeFantasia')}
                        helperText={getErrorMessage('nomeFantasia')}
                        name="nomeFantasia"
                        fullWidth
                        id="nomeFantasia"
                        label="Nome Fantasia"
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        value={createClienteForm.fields.login}
                        onChange={(e) => {
                          setCreateClienteFormLogin(e.target.value)
                        }}
                        error={hasError('login')}
                        helperText={getErrorMessage('login')}
                        name="login"
                        fullWidth
                        id="login"
                        label="Login"
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <Autocomplete
                        options={vendedores}
                        getOptionLabel={(option) => (option ? option.LoginUsuario : '')}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Vendedor"
                            fullWidth
                            error={hasError('idVendedor')}
                            helperText={getErrorMessage('idVendedor')}
                          />
                        )}
                        onChange={(event, newValue) => {
                          if (newValue) {
                            setCreateClienteFormVendedorId(newValue.IdUsuario)
                          }
                        }}
                        value={vendedores.find(
                          (vendedor) => Number(vendedor.IdUsuario) === Number(createClienteForm.fields?.idVendedor)
                        ) || null}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <FormControlLabel control={<Switch
                        checked={createClienteForm.fields.GerarLoteFinanceiro || false}
                        onChange={(e) => {
                          setCreateClienteFormGerarLoteFinanceiro(e.target.checked)
                        }}
                        name="faturarOmie"
                        color="primary"
                      />} label="Faturar Omie" />
                    </Grid>
                  </Grid>
                )}

                {tabValue === 1 && (
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <Typography
                        variant="h5"
                        color="primary"
                        fontWeight="bold"
                        textTransform={"uppercase"}
                        textAlign={'center'}
                        width={'100%'}
                        my={2}
                      >
                        Produtos
                      </Typography>
                      <Card variant='outlined'>
                        {
                          produtosTipoConsumo.map((produtoTipoConsumo, produtoIndex) => (
                            <Box
                              key={produtoIndex}
                              my={2}
                            >
                              <Box
                                style={{
                                  display: 'flex',
                                  flexDirection: 'row',
                                  alignItems: 'center',
                                  justifyContent: 'space-between',
                                  width: '100%',
                                }}
                              >
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={createClienteForm.fields.ProdutosTiposConsumos.some(
                                        (produto) => produto.IdProduto === produtoTipoConsumo.produto.IdProduto
                                      )}
                                      onChange={(event) => {
                                        if (event.target.checked) {
                                          vincularProdutoCreateClienteForm(produtoTipoConsumo.produto.IdProduto);
                                          produtoTipoConsumo.tipoConsumo.forEach((tipoConsumo) => {
                                            vincularTipoConsumoCreateClienteForm({
                                              idProduto: produtoTipoConsumo.produto.IdProduto,
                                              idTipoConsumo: tipoConsumo.IdTipoConsumo
                                            });
                                          });
                                        } else {
                                          removerProdutoCreateClienteForm(produtoTipoConsumo.produto.IdProduto);
                                        }
                                      }}
                                      name={`produto-${produtoIndex}`}
                                    />
                                  }
                                  label={produtoTipoConsumo.produto.Descricao}
                                  style={{ margin: 0 }}
                                />
                                <ExpandMore
                                  expand={expanded[produtoIndex] || false}
                                  onClick={() => handleExpandClick(produtoIndex.toString())}
                                  aria-expanded={expanded[produtoIndex] || false}
                                  aria-label="show more"
                                  style={{
                                    transform: expanded[produtoIndex] ? 'rotate(180deg)' : 'rotate(0deg)',
                                    cursor: 'pointer',
                                  }}
                                >
                                  <ExpandMoreIcon />
                                </ExpandMore>
                              </Box>

                              <Collapse
                                in={expanded[produtoIndex] || false}
                                timeout="auto"
                                unmountOnExit
                              >
                                <CardContent style={{ padding: '0.5rem', fontSize: '0.9rem' }}>
                                  <FormControl component="fieldset" fullWidth>
                                    <FormLabel component="legend" style={{ fontSize: '0.9rem', marginBottom: '0.5rem' }}>
                                      Escolha as variáveis
                                    </FormLabel>

                                    <TextField
                                      size="small"
                                      placeholder="Pesquisar variável..."
                                      variant="outlined"
                                      fullWidth
                                      sx={{ mb: 1 }}
                                      value={searchTerms[produtoTipoConsumo.produto.IdProduto] || ''}
                                      onChange={(e) => setSearchTerms(prev => ({
                                        ...prev,
                                        [produtoTipoConsumo.produto.IdProduto]: e.target.value
                                      }))}
                                    />

                                    <FormGroup style={{ paddingLeft: '1.5rem' }}>

                                      {produtoTipoConsumo.tipoConsumo
                                        .filter(tc =>
                                          !searchTerms[produtoTipoConsumo.produto.IdProduto] ||
                                          tc.Descricao.toLowerCase().includes(searchTerms[produtoTipoConsumo.produto.IdProduto].toLowerCase())
                                        )
                                        .map((tipoConsumo, tipoIndex) => (
                                          <FormControlLabel
                                            key={`produto-${produtoIndex}-tipo-${tipoIndex}`}
                                            control={
                                              <Checkbox
                                                checked={createClienteForm.fields.ProdutosTiposConsumos.some(
                                                  (produto) =>
                                                    produto.IdProduto === tipoConsumo.IdProduto &&
                                                    produto.IdTipoConsumo.includes(tipoConsumo.IdTipoConsumo)
                                                )}
                                                name={`produto-${produtoIndex}-tipo-${tipoIndex}`}
                                                onChange={(e) => {
                                                  if (e.target.checked) {
                                                    vincularTipoConsumoCreateClienteForm({
                                                      idProduto: tipoConsumo.IdProduto,
                                                      idTipoConsumo: tipoConsumo.IdTipoConsumo
                                                    });
                                                  } else {
                                                    removerTipoConsumoCreateClienteForm({
                                                      idProduto: tipoConsumo.IdProduto,
                                                      idTipoConsumo: tipoConsumo.IdTipoConsumo
                                                    });
                                                  }
                                                }}
                                              />
                                            }
                                            label={tipoConsumo.Descricao}
                                          />
                                        ))}
                                    </FormGroup>
                                  </FormControl>
                                </CardContent>
                              </Collapse>

                              <Divider />
                            </Box>
                          ))
                        }
                      </Card>
                    </Grid>
                  </Grid>
                )}

                <Box sx={{ display: tabValue === 2 ? 'block' : 'none' }}>
                  <PlanosVelesTab ref={planosVelesRef} IdCliente={0} viewMode="create" />
                </Box>

                <Box sx={{ display: tabValue === 3 ? 'block' : 'none' }}>
                  <HistoricoPlanosTab IdCliente={0} />
                </Box>

                <Box sx={{ display: tabValue === 4 ? 'block' : 'none' }}>
                  <ContratoTab IdCliente={0} isEditMode={true} />
                </Box>

                <Box sx={{ display: tabValue === 5 ? 'block' : 'none' }}>
                  <NotaFiscalTab ref={notaFiscalRef} IdCliente={0} isEditing={true} />
                </Box>
              </Box>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose}>Cancelar</Button>
              <Button variant="contained" type="submit">Criar Cliente</Button>
            </DialogActions>
          </Dialog>
      }
    </>
  )
}